"use client";

import { CategoryData } from "@/services/dataTypes";
import Link from "next/link";
import React, { useState } from "react";
import { faChevronDown, faChevronUp, faArrowRight, FontAwesomeIcon } from "@/constants/icons";

interface Props {
    categories: CategoryData[];
    pageSlug: string;
    categoryName?: string;
}

const CategorySidebarProduct = ({ categories, pageSlug, categoryName }: Props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const displayed = isExpanded ? categories?.slice(0, 10) : categories?.slice(0, 5);

    return (
        <div>
            <div className="flex items-center gap-2 mb-4">
                <span className="w-4 h-[2px] bg-[#D61C4E] rounded-full" />
                <h4 className="text-[10px] font-black uppercase tracking-[0.25em] text-[#D61C4E]">
                    {categoryName ? `Related to ${categoryName}` : "Browse Categories"}
                </h4>
            </div>

            <div className="space-y-0.5">
                {displayed?.map((category, i) => (
                    <Link
                        key={i}
                        href={`/${pageSlug}/${category.url}`}
                        className="group flex items-center justify-between px-3 py-2.5 rounded-xl
                                   border border-transparent
                                   hover:bg-[#D61C4E]/5 hover:border-[#D61C4E]/15
                                   transition-all duration-200 no-underline"
                    >
                        <div className="flex items-center gap-2.5">
                            <span className="w-1.5 h-1.5 rounded-full bg-slate-200
                                             group-hover:bg-[#D61C4E] transition-colors shrink-0" />
                            <span className="text-[13px] font-medium text-slate-600
                                             group-hover:text-[#D61C4E] transition-colors">
                                {category?.name}
                            </span>
                        </div>
                        <FontAwesomeIcon
                            icon={faArrowRight}
                            className="w-2.5 h-2.5 text-slate-300 opacity-0 group-hover:opacity-100
                                       group-hover:text-[#D61C4E] group-hover:translate-x-0.5
                                       transition-all duration-200"
                        />
                    </Link>
                ))}
            </div>

            {categories?.length > 5 && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="w-full mt-3 pt-3 flex items-center justify-center gap-1.5
                               text-[10px] font-black uppercase tracking-[0.2em]
                               text-slate-400 hover:text-[#D61C4E] transition-colors
                               border-t border-slate-100"
                >
                    {isExpanded ? (
                        <>Show Less <FontAwesomeIcon icon={faChevronUp} className="w-2.5 h-2.5" /></>
                    ) : (
                        <>Show More <FontAwesomeIcon icon={faChevronDown} className="w-2.5 h-2.5" /></>
                    )}
                </button>
            )}
        </div>
    );
};

export default CategorySidebarProduct;
